import type { WebAppConfig } from '../model/types';

type ProfileLoader = () => Promise<{ default: WebAppConfig }>;

const profileLoaders = {
  default: () => import('../profiles/default'),
  minimal: () => import('../profiles/minimal'),
} satisfies Record<string, ProfileLoader>;

export const appProfileIds = Object.keys(profileLoaders);

export async function loadAppProfile(
  profileId = import.meta.env.VITE_APP_PROFILE ?? 'default',
): Promise<WebAppConfig> {
  const loader = profileLoaders[profileId as keyof typeof profileLoaders];
  if (!loader) {
    throw new Error(
      `Unknown App Profile: ${profileId}. Expected one of: ${appProfileIds.join(', ')}`,
    );
  }
  const module = await loader();
  return module.default;
}
